'use client'
import React, { useCallback } from 'react'
import { Input } from '../ui/input'
import { Button } from '../ui/button'
import { ArrowBigRightDash, LoaderCircle, SendIcon } from 'lucide-react'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import commentApi from '~/apis/comment'
import { toast } from 'sonner'
type CommentFormProps = {
    isMobile?: boolean
    blogId: string
    slug: string
}

const CommentForm = ({ isMobile, blogId, slug }: CommentFormProps) => {
    const queryClient = useQueryClient()
    const [formComment, setFormComment] = React.useState({
        content: ''
    })
    const commentForm = useMutation({
        mutationFn: () => commentApi.createComment({ content: formComment.content, blogId: blogId }),
        onError: (err) => {
            toast.error(err.message)
        },
        onSuccess: (data) => {
            setFormComment({ content: '' })
            queryClient.invalidateQueries({
                queryKey: ['comments', slug]
            })
        }
    })
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setFormComment({ ...formComment, content: e.target.value })
    }
    const handleComment = useCallback(() => {
        commentForm.mutate()
    }, [commentForm])
    React.useEffect(() => {
        const down = (e: KeyboardEvent) => {
            if (e.key === 'Enter') {
                e.preventDefault()
                handleComment()
            }
        }
        document.addEventListener('keydown', down)
        return () => document.removeEventListener('keydown', down)
    }, [handleComment])
    return (
        <>
            {!isMobile && (
                <div className='flex w-full flex-col gap-2'>
                    <Input
                        value={formComment.content}
                        onChange={handleChange}
                        placeholder='Nhập bình luận.'
                        className='shadow-none focus-visible:ring-0'
                    />
                    <div className='flex items-center justify-between'>
                        <p className='text-sm text-gray-400'>Lưu ý: Không bình luận span</p>
                        <Button
                            disabled={!formComment.content}
                            onClick={handleComment}
                            className='h-auto bg-second! py-1 text-primary hover:bg-transparent'
                        >
                            {!commentForm.isPending && 'Đăng'}
                            {commentForm.isPending && <LoaderCircle />}
                        </Button>
                    </div>
                </div>
            )}
            {isMobile && (
                <div className='sticky flex h-14 w-full items-center gap-2 py-2 border-t'>
                    <Input
                        value={formComment.content}
                        onChange={handleChange}
                        placeholder='Nhập bình luận.'
                        className='h-auto border-none py-2 shadow-none focus-visible:ring-0'
                    />
                    <Button
                        disabled={!formComment.content}
                        onClick={handleComment}
                        variant={'secondary'}
                        size={'icon'}
                        className='mr-2 shrink-0 rounded-full'
                    >
                        {!commentForm.isPending && <SendIcon />}
                        {commentForm.isPending && <LoaderCircle />}
                    </Button>
                </div>
            )}
        </>
    )
}

export default CommentForm
